import * as angular from 'angular';

import { getCsrfToken } from '@mode/shared/util-js';

import { AccountResource, formSubmit } from '@mode/legacy/data-access-model-js';

const TIMEOUT_PRESETS = [7, 14, 21, 30];
const SESSION_EXPIRATION_DISABLED_TEXT =
  'Session expiration can only be customized for workspaces with more than one member.';

class SessionTimeoutInputController {
  private disabledTooltipText = SESSION_EXPIRATION_DISABLED_TEXT;
  private orgName: string;
  private timeout: any;
  private _timeout: any;
  private customTimeout: any;
  private account: AccountResource;
  private timeoutLink: string;
  private emptyTimeoutLink: boolean;
  private customTimeoutRadioButton: HTMLInputElement;

  static $inject = ['$scope', '$element', '$window', 'AccountModel'];

  constructor(
    private $scope,
    private $element,
    private $window,
    private AccountModel
  ) {}

  $onInit() {
    this.customTimeoutRadioButton = this.$element.find('#custom_timeout_radio')[0];
    this._timeout = this.timeout;
    if (this.isCustomTimeout()) {
      this.customTimeout = this.timeout;
    }

    this.AccountModel.find({
      username: this.orgName,
      useEntryPath: true,
    }).then((account) => {
      this.account = account;
      this.timeoutLink = account.memberSessionTimeoutLink;
      if (this.timeoutLink.length === 1) {
        this.emptyTimeoutLink = true;
      }
    });
  }

  focusInputField() {
    this.$element.find('#custom_timeout').focus();
  }

  customisChecked() {
    return this.customTimeoutRadioButton.checked;
  }

  isCustomTimeout() {
    if (!TIMEOUT_PRESETS.includes(this._timeout) || this.customTimeout || this.customisChecked()) {
      return true;
    }
    return false;
  }

  buttonDisabled() {
    return !this.$scope.customTimeoutForm.$valid || this.emptyTimeoutLink;
  }

  submitTimeout() {
    if (this.buttonDisabled()) {
      return false;
    }
    const session_timeout = this.isCustomTimeout() && this.customisChecked() ? this.customTimeout : this._timeout;

    formSubmit(this.timeoutLink, {
      fields: {
        _method: 'patch',
        authenticity_token: getCsrfToken(this.$window.document),
        session_timeout: session_timeout,
      },
    });
  }
}

const SessionTimeoutInputComponent: angular.IComponentOptions = {
  controller: SessionTimeoutInputController,
  controllerAs: 'ctrl',
  bindings: {
    timeout: '<',
    orgName: '<',
  },
  template: `
    <div>
      <form name="customTimeoutForm">
        <input ng-model="ctrl._timeout" type="radio" ng-value="7" name="organization_account[session_timeout]" id="organization_account_session_timeout_7">
        <label class="preset-option" for="organization_account_session_timeout_7">7 days</label>

        <input ng-model="ctrl._timeout" type="radio" ng-value="14" name="organization_account[session_timeout]" id="organization_account_session_timeout_14">
        <label class="preset-option" for="organization_account_session_timeout_14">14 days</label>

        <input ng-model="ctrl._timeout" type="radio" ng-value="21" name="organization_account[session_timeout]" id="organization_account_session_timeout_21">
        <label class="preset-option" for="organization_account_session_timeout_21">21 days</label>

        <input ng-model="ctrl._timeout" type="radio" ng-value="30" name="organization_account[session_timeout]" id="organization_account_session_timeout_30">
        <label class="preset-option" for="organization_account_session_timeout_30">30 days (default)</label>

        <input ng-click="ctrl.focusInputField()" ng-checked="ctrl.isCustomTimeout()" type="radio" name="organization_account[session_timeout]" id="custom_timeout_radio">
        <label for="custom_timeout">Custom (1-99 days)</label>
        <input ng-model="ctrl.customTimeout" type="number" min="1" max="99" name="organization_account[session_timeout]" id="custom_timeout">

        <div>
          <capra-button
            (clicked)="ctrl.submitTimeout()"
            disabled="{{ctrl.buttonDisabled()}}"
            class="submit-button"
            ng-attr-uib-tooltip="{{ ctrl.emptyTimeoutLink ? ctrl.disabledTooltipText : undefined }}"
            tooltip-placement="right"
            tooltip-class="disabled-tooltip"
            text="Save"
          />
        </div>
      </form>
    </div>
  `,
};

angular.module('mode.components').component('sessionTimeoutInput', SessionTimeoutInputComponent);
